export function FieldsReplacer<T, K extends keyof T>(
  source: T,
  destination: any,
  fields: { from: K; to: any }[]
) {
  let props: { [key: string]: any } = {};

  for (let field of fields) {
    let newValue;
    const { from, to } = field;
    let actualValue = source[from];

    // in some cases documents could not have some properties
    if (!destination[to]) continue;

    // if the value to be changed is an array
    if (Array.isArray(actualValue)) {
      // and the value in the origin is an array of values
      if (Array.isArray(destination[to])) {
        newValue = actualValue.filter(el => {
          if (el.hasOwnProperty('_id')) {
            return destination[to].includes(el._id);
          } else {
            return destination[to].includes(el);
          }
        });
      } else {
        // or the value in the origin is not an array of values
        newValue = actualValue.filter(el => destination[to].includes(el._id));
      }
    } else {
      // if the value to be changed is not an array, we will interpolate it directly

      newValue = actualValue;
    }

    // if new value could not be changed we left the original value
    props = { ...props, [to]: newValue ?? actualValue };
  }

  return props;
}

export const getActionClassname = (_action?: string) => {
  if (!_action) return '';
  const action = _action.toLowerCase();
  if (action.includes('delete')) return 'bg-red-light text-white';
  else if (action.includes('create')) return 'bg-green text-white';
  else return 'bg-yellow-lighter';
};

export function syntaxHighlight(json: string) {
  if (!json) return '';

  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  return json.replace(
    /* eslint-disable-next-line max-len */
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    function (match: string) {
      let cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    }
  );
}
